<template>
  <div id="app">
    <NavBar />
    <main class="main-content">
      <HeroSection />
      <ProfileSection />
      <AdvantagesSection />
      <BusinessSection />
      <CustomerSection />
      <CapabilitySection />
      <FieldGallerySection />
      <TeamSection />
      <ContactSection />
    </main>
    <SiteFooter />
  </div>
</template>

<script>
// 导入所有组件，使用数字前缀保持文件顺序清晰
import NavBar from './components/01_NavBar.vue';
import HeroSection from './components/02_HeroSection.vue';
import ProfileSection from './components/03_ProfileSection.vue';
import AdvantagesSection from './components/Advantages.vue';
import BusinessSection from './components/04_BusinessSection.vue';
import CustomerSection from './components/05_CustomerSection.vue';
import CapabilitySection from './components/09_CapabilitySection.vue';
import FieldGallerySection from './components/10_FieldGallerySection.vue';
import TeamSection from './components/06_TeamSection.vue';
import ContactSection from './components/07_ContactSection.vue';
import SiteFooter from './components/08_Footer.vue';

export default {
  name: 'App',
  components: {
    NavBar,
    HeroSection,
    ProfileSection,
    AdvantagesSection,
    BusinessSection,
    CustomerSection,
    CapabilitySection,
    FieldGallerySection,
    TeamSection,
    ContactSection,
    SiteFooter
  },
  // 组件挂载后，确保页面从顶部开始显示
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style>
/* 全局样式重置，移除默认边距和滚动条问题 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: 'PingFang SC', 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
  background: #f5f7fa;
  overflow-x: hidden;
}

#app {
  min-height: 100vh;
  background: #f5f7fa;
  overflow-x: hidden;
}

/* 主内容区域：确保所有内容区块依次排列 */
.main-content {
  display: flex;
  flex-direction: column;
}

/* 移除所有区块之间的默认间距，由各组件内部控制内边距 */
</style>